import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './ContactData.css';
import Input from '../../../components/UI/Input/Input';
import { checkValidity } from '../../../shared/utility';

class ContactData extends Component {
    state = {
        orderForm: {
            name: {
                focus: true,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Full Name',
                    value: '',
                },

                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            address: {
                focus: false,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Street Address'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            city: {
                focus: false,
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'City'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false
            },
            zip: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'ZIP Code',
                    max: 99999
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 5,
                    maxLength: 5,
                    isNumeric: true
                },
                valid: false,
                touched: false
            },
            phone: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'Phone',
                    max: 9999999999
                },
                value: '',
                validation: {
                    required: false,
                    minLength: 0,
                    maxLength: 10,
                    isNumeric: true
                },
                valid: false,
                touched: false
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'E-Mail'
                },
                value: '',
                validation: {
                    required: false,
                    isEmail: true
                },
                valid: false,
                touched: false
            }
        }
    }

    inputBlurredHandler(event, inputIdentifier) {
        let valid = checkValidity(event.target.value, this.state.orderForm[inputIdentifier].validation);
        if (valid) {
            if (inputIdentifier === 'address' || inputIdentifier === 'city' || inputIdentifier === 'zip') {

                let address = this.props.address;
                let city = this.props.city;
                let zip = this.props.zip;
                if (inputIdentifier === 'address') {
                    address = event.target.value;
                }
                else if (inputIdentifier === 'city') {
                    city = event.target.value;
                }
                else {
                    zip = event.target.value;
                }

                if (address !== '' && city !== '' && zip !== '') {
                    let geoAddress = address + ',' + city + ' TX ' + zip;

                    this.props.onAddressChanged(address, city, zip, geoAddress);
                }
            }
            this.props.onDataChanged(inputIdentifier + '_valid', valid);
            this.props.onDataChanged(inputIdentifier + '_touched', true);
            this.props.onDataChanged(inputIdentifier, event.target.value);
        }
    }

    inputChangedHandler = (event, inputIdentifier) => {
        
        let valid = checkValidity(event.target.value, this.state.orderForm[inputIdentifier].validation);
        this.props.onDataChanged(inputIdentifier + '_valid', valid);
        this.props.onDataChanged(inputIdentifier + '_touched', true);
        this.props.onDataChanged(inputIdentifier, event.target.value);
    }

    render() {

        const formElementsArray = [];
        for (let key in this.state.orderForm) {
            formElementsArray.push({
                id: key,
                config: this.state.orderForm[key]
            });
        }
        let form = (
            <form onSubmit={this.orderHandler}>
                {formElementsArray.map(formElement => (
                    <Input
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={this.props[formElement.id]}
                        hasFocus={formElement.config.focus}
                        invalid={!this.props[formElement.id + '_valid']}
                        shouldValidate={formElement.config.validation}
                        touched={this.props[formElement.id + '_touched']}
                        blurred={(event) => this.inputBlurredHandler(event, formElement.id)}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                ))}
            </form>
        );

        return (
            <div className={classes.ContactData}>
                <h4>Enter Customer Data</h4>
                {form}
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        name: state.orders.order.name,
        address: state.orders.order.address,
        city: state.orders.order.city,
        zip: state.orders.order.zip,
        phone: state.orders.order.phone,
        email: state.orders.order.email,

        name_valid: state.orders.order.name_valid,
        address_valid: state.orders.order.address_valid,
        city_valid: state.orders.order.city_valid,
        zip_valid: state.orders.order.zip_valid,
        phone_valid: state.orders.order.phone_valid,
        email_valid: state.orders.order.email_valid,

        name_touched: state.orders.order.name_touched,
        address_touched: state.orders.order.address_touched,
        city_touched: state.orders.order.city_touched,
        zip_touched: state.orders.order.zip_touched,
        phone_touched: state.orders.order.phone_touched,
        email_touched: state.orders.order.email_touched,
        inDeliveryArea: state.orders.order.isInArea,
        isApproved: state.orders.token !== null
    };
}


export default connect(mapStateToProps)(ContactData);


// WEBPACK FOOTER //
// ./src/components/Order/ContactData/ContactData.js